<div
  class="fixed top-[100px] left-sm bottom-sm bg-card rounded-lg shadow-card flex flex-col z-1000 transition-[width] duration-300"
  [ngClass]="
    layoutService.isSidebarCollapsed()
      ? 'w-16 pt-xs pb-11'
      : 'w-52 pt-[18px] pb-6'
  "
>
  <!-- Sections Container -->
  <div
    class="flex flex-col flex-1 w-full overflow-y-auto scrollbar-hide"
    [ngClass]="
      layoutService.isSidebarCollapsed()
        ? 'items-center px-prop'
        : 'px-xs'
    "
  >
    <!-- Menu Section -->
    <div
      class="flex flex-col gap-sm"
      [ngClass]="
        layoutService.isSidebarCollapsed() ? 'items-center' : 'w-full'
      "
    >
      @for (item of menuItems(); track item.id) {
      <div
        class="transition-all duration-300 flex flex-col"
        [class.w-full]="!layoutService.isSidebarCollapsed()"
        [class.sidebar-module-group--active]="activeModule() === item.id"
        [ngClass]="{
          'bg-primary/5 rounded-lg p-xs gap-xs':
            activeModule() === item.id && !layoutService.isSidebarCollapsed(),
          'bg-primary/5 rounded-lg p-prop gap-prop items-center':
            activeModule() === item.id && layoutService.isSidebarCollapsed(),
          'items-start':
            activeModule() !== item.id && layoutService.isSidebarCollapsed()
        }"
      >
        <!-- Main Module Icon + Label -->
        <a
          [class]="moduleLinkClass(item.id)"
          [routerLink]="item.route"
          [matTooltip]="
            layoutService.isSidebarCollapsed() ? (item.label | translate) : ''
          "
          matTooltipPosition="right"
          appendTo="body"
          (click)="onModuleClick(item.id, item.route); $event.preventDefault()"
        >
          <span
            class="sidebar-icon shrink-0 w-4 h-4 flex items-center justify-center overflow-hidden"
            aria-hidden="true"
          >
            @if (item.id === 'import') {
            <ic-import
              [height]="16"
              [width]="16"
              [startColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-start-color)'
                  : 'var(--color-light-text)'
              "
              [endColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-end-color)'
                  : 'var(--color-light-text)'
              "
            ></ic-import>
            } @else if (item.id === 'export') {
            <ic-export
              [height]="16"
              [width]="16"
              [startColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-start-color)'
                  : 'var(--color-light-text)'
              "
              [endColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-end-color)'
                  : 'var(--color-light-text)'
              "
            ></ic-export>
            } @else if (item.id === 'transit') {
            <ic-transit
              [height]="16"
              [width]="16"
              [startColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-start-color)'
                  : 'var(--color-light-text)'
              "
              [endColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-end-color)'
                  : 'var(--color-light-text)'
              "
            ></ic-transit>
            } @else if (item.id === 'emcs') {
            <ic-emcs
              [height]="16"
              [width]="16"
              [startColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-start-color)'
                  : 'var(--color-light-text)'
              "
              [endColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-end-color)'
                  : 'var(--color-light-text)'
              "
            ></ic-emcs>
            } @else if (item.id === 'rto') {
            <ic-warehouse
              [height]="16"
              [width]="16"
              [startColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-start-color)'
                  : 'var(--color-light-text)'
              "
              [endColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-end-color)'
                  : 'var(--color-light-text)'
              "
            ></ic-warehouse>
            } @else if (item.id === 'tasks') {
            <ic-wallet
              [height]="16"
              [width]="16"
              [startColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-start-color)'
                  : 'var(--color-light-text)'
              "
              [endColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-end-color)'
                  : 'var(--color-light-text)'
              "
            ></ic-wallet>
            } @else if (item.id === 'settings') {
            <ic-globe
              [height]="16"
              [width]="16"
              [startColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-start-color)'
                  : 'var(--color-light-text)'
              "
              [endColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-end-color)'
                  : 'var(--color-light-text)'
              "
            ></ic-globe>
            } @else if (item.id === 'dashboard') {
            <ic-graph
              [height]="16"
              [width]="16"
              [startColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-start-color)'
                  : 'var(--color-light-text)'
              "
              [endColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-end-color)'
                  : 'var(--color-light-text)'
              "
            ></ic-graph>
            } @else if (item.id === 'commodity-classifier') {
            <ic-commodity-classifier
              [height]="16"
              [width]="16"
              [startColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-start-color)'
                  : 'var(--color-light-text)'
              "
              [endColor]="
                activeModule() === item.id
                  ? 'var(--color-primary-end-color)'
                  : 'var(--color-light-text)'
              "
            ></ic-commodity-classifier>
            }
          </span>
          @if (!layoutService.isSidebarCollapsed()) {
          <span
            class="text-xs font-medium truncate min-w-0"
            [ngClass]="
              activeModule() === item.id
                ? 'text-primary'
                : 'text-gray-text'
            "
          >
            {{ item.label | translate }}
          </span>
          }
        </a>

        <!-- Sub Tabs (Only for active module) -->
        @if (activeModule() === item.id && activeModuleTabs().length > 0) {
        <div
          class="flex flex-col w-full"
          [ngClass]="
            layoutService.isSidebarCollapsed()
              ? 'gap-prop items-center'
              : 'gap-xs pl-xs'
          "
        >
          @for (tab of activeModuleTabs(); track tab.id) {
          <app-active-container
            [active]="isTabActive(tab.route, $any(tab).queryParams)"
            [bgStyle]="
              isTabActive(tab.route, $any(tab).queryParams)
                ? 'var(--bg-card-soft-white)'
                : 'rgba(255, 255, 255, 0.2)'
            "
            [borderOpacity]="0.3"
            [borderRadius]="
              layoutService.isSidebarCollapsed()
                ? 'var(--radius-md)'
                : 'var(--radius-lg)'
            "
            class="overflow-hidden shrink-0"
            [class.rounded-lg]="!layoutService.isSidebarCollapsed()"
            [class.w-full]="!layoutService.isSidebarCollapsed()"
            [class.w-9]="layoutService.isSidebarCollapsed()"
            [class.h-9]="layoutService.isSidebarCollapsed()"
            [class.rounded-md]="layoutService.isSidebarCollapsed()"
          >
            <a
              class="flex items-center transition-all cursor-pointer"
              [class.w-full]="!layoutService.isSidebarCollapsed()"
              [class.h-10]="!layoutService.isSidebarCollapsed()"
              [class.gap-xs]="!layoutService.isSidebarCollapsed()"
              [class.px-xs]="!layoutService.isSidebarCollapsed()"
              [class.rounded-lg]="
                !isTabActive(tab.route, $any(tab).queryParams) &&
                !layoutService.isSidebarCollapsed()
              "
              [class.shadow-card]="
                !isTabActive(tab.route, $any(tab).queryParams) &&
                !layoutService.isSidebarCollapsed()
              "
              [class.justify-center]="layoutService.isSidebarCollapsed()"
              [class.w-9]="layoutService.isSidebarCollapsed()"
              [class.h-9]="layoutService.isSidebarCollapsed()"
              [class.shrink-0]="layoutService.isSidebarCollapsed()"
              [routerLink]="tab.route"
              [queryParams]="$any(tab).queryParams"
              [matTooltip]="
                layoutService.isSidebarCollapsed()
                  ? (tab.label | translate)
                  : ''
              "
              matTooltipPosition="right"
              appendTo="body"
              (click)="
                onTabClick(tab.route, $any(tab).queryParams);
                $event.preventDefault()
              "
            >
              <span
                class="sidebar-icon shrink-0 w-4 h-4 flex items-center justify-center overflow-hidden"
                aria-hidden="true"
              >
                @if (tab.icon === 'ic-list') {
                <ic-list
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-list>
                } @else if (tab.icon === 'ic-warning') {
                <ic-warning
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-warning>
                } @else if (tab.icon === 'ic-graph') {
                <ic-graph
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-graph>
                } @else if (tab.icon === 'ic-user-role') {
                <ic-user-role-solid
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-user-role-solid>
                } @else if (tab.icon === 'ic-user') {
                <ic-user
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-user>
                } @else if (tab.icon === 'ic-broker') {
                <ic-broker-solid
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-broker-solid>
                } @else if (tab.icon === 'ic-client') {
                <ic-client-solid
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-client-solid>
                } @else if (tab.icon === 'ic-manifest-template') {
                <ic-manifest-template
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-manifest-template>
                } @else if (tab.icon === 'ic-declaration-template') {
                <ic-declaration-template
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-declaration-template>
                } @else if (tab.icon === 'ic-copy') {
                <app-ic-copy
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></app-ic-copy>
                } @else if (tab.icon === 'ic-info') {
                <ic-info
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-info>
                } @else if (tab.icon === 'ic-import') {
                <ic-import
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-import>
                } @else if (tab.icon === 'transit-arrival-icon') {
                <ic-transit-arrival
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-transit-arrival>
                } @else if (tab.icon === 'transit-departure-icon') {
                <ic-transit-departure
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-transit-departure>
                } @else if (tab.icon === 'ic-export-shipment') {
                <ic-export
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-export>
                } @else if (tab.icon === 'ic-plane') {
                <ic-plane
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-plane>
                } @else if (tab.icon === 'ic-parcelbox') {
                <ic-parcelbox
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-parcelbox>
                } @else if (tab.icon === 'ic-transit') {
                <ic-transit
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-transit>
                } @else if (tab.icon === 'ic-emcs') {
                <ic-emcs
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-emcs>
                } @else if (tab.icon === 'ic-warehouse') {
                <ic-warehouse
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-warehouse>
                } @else if (tab.icon === 'ic-wallet') {
                <ic-wallet
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-wallet>
                } @else if (tab.icon === 'ic-globe') {
                <ic-globe
                  [height]="16"
                  [width]="16"
                  [startColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-start-color)'
                      : 'var(--color-light-text)'
                  "
                  [endColor]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'var(--color-primary-end-color)'
                      : 'var(--color-light-text)'
                  "
                ></ic-globe>
                } @else {
                <i
                  [class]="tab.icon"
                  [ngClass]="
                    isTabActive(tab.route, $any(tab).queryParams)
                      ? 'text-primary'
                      : 'text-light-text'
                  "
                  class="text-sm"
                ></i>
                }
              </span>
              @if (!layoutService.isSidebarCollapsed()) {
              <span
                class="text-xs font-medium truncate min-w-0"
                [ngClass]="
                  isTabActive(tab.route, $any(tab).queryParams)
                    ? 'text-primary'
                    : 'text-gray-text'
                "
              >
                {{ tab.label | translate }}
              </span>
              }
            </a>
          </app-active-container>
          }
        </div>
        }
      </div>
      }
    </div>
  </div>

  <button
    type="button"
    appClickable
    class="absolute bottom-xs flex items-center justify-center w-8 h-8 rounded-md bg-bg-soft border border-line hover:bg-white shadow-card"
    [ngClass]="
      layoutService.isSidebarCollapsed() ? 'left-xs' : 'right-xs'
    "
    [matTooltip]="
      (layoutService.isSidebarCollapsed() ? 'expand' : 'collapse') | translate
    "
    matTooltipPosition="right"
    appendTo="body"
    [attr.aria-expanded]="!layoutService.isSidebarCollapsed()"
    [attr.aria-label]="
      (layoutService.isSidebarCollapsed() ? 'expand' : 'collapse') | translate
    "
    (click)="layoutService.toggleSidebarCollapsed()"
  >
    @if (layoutService.isSidebarCollapsed()) {
    <ic-chevron-right
      [width]="12"
      [height]="12"
      [startColor]="'var(--color-primary-start-color)'"
      [endColor]="'var(--color-primary-end-color)'"
    ></ic-chevron-right>
    } @else {
    <ic-chevron-left
      [width]="12"
      [height]="12"
      [startColor]="'var(--color-primary-start-color)'"
      [endColor]="'var(--color-primary-end-color)'"
    ></ic-chevron-left>
    }
  </button>
</div>
